import moment from 'moment';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IssueReport } from '../../api/types';

interface IssueReportCommentsProps {
    issueReport: IssueReport;
}

const IssueReportComments = ({ issueReport }: IssueReportCommentsProps) => {
    const { t } = useTranslation();
    const commentsEndRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (commentsEndRef.current) {
            commentsEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [issueReport.comments?.length]);

    return (
        <div className={'bg-white border border-gray-300 rounded-xl shadow w-full max-w-2xl mx-auto p-6 flex flex-col h-[85vh]'}>
            <div className={'mb-2'}>
                <span className={'block font-bold text-base mb-1'}>{t('issue_report.issue_description') || 'Description'}</span>
                <p className={'text-gray-800 mb-2'}>{issueReport.message}</p>
                <p className={'text-base text-gray-500'}>
                    {t('issue_report.created_by')} {issueReport?.profileInfo?.name || issueReport?.userCreatorEmail || t('common.end_user')} •{' '}
                    {issueReport?.createdAt ? moment(issueReport.createdAt).format('ll LT') : ''}
                </p>
            </div>
            <h3 className={'text-lg font-semibold mb-4'}>{t('issue_reports.comments')}</h3>
            <div className={'flex flex-col gap-4 mb-4 overflow-y-auto flex-1'}>
                {issueReport.comments && issueReport.comments.length > 0 ? (
                    issueReport.comments.map((comment, idx) => (
                        <div key={idx} className={'flex items-start gap-3'}>
                            {comment.profileInfo?.picture && (
                                <img src={comment.profileInfo.picture} alt={comment.profileInfo.name} className={'w-8 h-8 rounded-full'} />
                            )}
                            <div>
                                <div className={'flex items-center gap-2'}>
                                    <span className={'font-semibold'}>
                                        {comment.type === 'booking_deleted'
                                            ? t('issue_reports.comment_system_author')
                                            : comment.profileInfo?.name || 'User'}
                                    </span>
                                    <span className={'text-xs text-gray-500'}>{comment.created_at ? moment(comment.created_at).format('ll LT') : ''}</span>
                                </div>
                                <div className={'text-gray-800'}>
                                    {comment.type === 'booking_deleted'
                                        ? t('issue_reports.comment_booking_deleted', {
                                            bookingNumber: comment.booking_number || t('common.not_applicable'),
                                        })
                                        : comment.message}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className={'text-gray-500'}>{t('issue_reports.no_comments')}</div>
                )}
                <div ref={commentsEndRef} />
            </div>
        </div>
    );
};

export default IssueReportComments;
